export const AVERAGE_USER_EMAIL = '__AVERAGE__';
export const AVERAGED_SCORE_AUTHOR = 'averaged';
